var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivedApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 14C0.855556 14 0.583333 13.8833 0.35 13.65C0.116667 13.4167 0 13.1444 0 12.8333V2.66389C0 2.46944 0.0194444 2.30417 0.0583333 2.16806C0.0972222 2.03194 0.168519 1.90556 0.272222 1.78889L1.36111 0.311111C1.46481 0.194444 1.58472 0.113426 1.72083 0.0680556C1.85694 0.0226852 2.01824 0 2.20473 0H11.7953C11.9818 0 12.1398 0.0226852 12.2694 0.0680556C12.3991 0.113426 12.5157 0.194444 12.6194 0.311111L13.7278 1.78889C13.8315 1.90556 13.9028 2.03194 13.9417 2.16806C13.9806 2.30417 14 2.46944 14 2.66389V12.8333C14 13.1444 13.8833 13.4167 13.65 13.65C13.4167 13.8833 13.1444 14 12.8333 14H1.16667ZM1.49722 2.06111H12.4833L11.7754 1.16667H2.19722L1.49722 2.06111ZM1.16667 3.22778V12.8333H12.8333V3.22778H1.16667ZM7 11.0833L10.0333 8.05L9.25556 7.27222L7.58333 8.94444V5.03611H6.41667V8.94444L4.74444 7.27222L3.96667 8.05L7 11.0833Z",
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedApplications);
export default __webpack_public_path__ + "static/media/archived_applications.181e7bda2582bb35abf03ccff70c2819.svg";
export { ForwardRef as ReactComponent };